// ModalVentasRelacionadas.js
import React, { Component } from 'react';
import { Modal, Table, message } from 'antd';
import axios from 'axios';
import { connect } from "react-redux";

import moment from 'moment';

// Función para formatear dinero (puedes ajustarla según la tuya)
const formatCurrency = (value) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);

class ModalVentasRelacionadas extends Component {
    state = {
        ventasData: [],
        loading: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible && this.props.ventasIds?.length > 0) {
            this.fetchVentas();
        }
    }

    fetchVentas = () => {
        this.setState({ loading: true });
        axios.post('/ventas/selectVentasByIds', { ids: this.props.ventasIds })
            .then(res => {
                if (res.data.success === 2) {
                    this.setState({ ventasData: res.data.data });
                } else {
                    message.error('No se pudieron cargar las ventas relacionadas.');
                }
            })
            .catch(err => {
                console.error("Error fetching related sales:", err);
                message.error('Error de red al cargar las ventas.');
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    handleDoubleClick = (ventaId) => {
        this.props.history.push("/panel/verVenta", { id: ventaId });
        this.props.onClose();
    }

    render() {
        const { visible, onClose } = this.props;

        const columns = [
            {
                title: "Folio",
                dataIndex: "numero",
                key: "numero",
                width: 100,
            },
            {
                title: "Cliente",
                dataIndex: "cliente",
                key: "cliente",
                ellipsis: true,
            },
            {
                title: "Fecha",
                dataIndex: "fechaVenta",
                key: "fechaVenta",
                render: (value) => moment(value).format("DD/MM/YY"),
                width: 120,
            },
            {
                title: "Total",
                dataIndex: "total",
                key: "total",
                align: "right",
                render: (value) => formatCurrency(value),
                width: 150,
            },
        ];

        return (
            <Modal
                title="Ventas Incluidas en la Factura Global"
                visible={visible}
                onCancel={onClose}
                footer={null}
                width={800}
            >
                <Table
                    columns={columns}
                    dataSource={this.state.ventasData}
                    loading={this.state.loading}
                    rowKey="_id"
                    size="small"
                    pagination={false}
                    onRow={(record) => ({
                        onDoubleClick: () => this.handleDoubleClick(record._id),
                    })}
                />
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};
export default connect(mapStateToProps)(ModalVentasRelacionadas);